import FormBaseModel from '@cp-models/FormBaseModel'

export default class ContractPlan extends FormBaseModel {
    casts()
    {
        return {
            'id': 'number',
            'connection': 'string',
            'contract_id': 'number',
            'company_id': 'number',
            'plan_id': 'number',
            'main_contract_plan_id': 'number',
            'hash': 'string',
            'start_at': 'any',
            'end_at': 'any',
            'sign_at': 'any',
            'code': 'string',
            'created_at': 'any',
            'updated_at': 'any',
            'deleted_at': 'any',
        }
    }

    get startAt()
    {
        return this.formatDate(this.start_at)
    }

    get endAt()
    {
        return this.formatDate(this.end_at)
    }

    get signAt()
    {
        return this.formatDate(this.sign_at)
    }

    get createdAt()
    {
        return this.formatDate(this.created_at)
    }

    get updatedAt()
    {
        return this.formatDate(this.updated_at)
    }

    get deletedAt()
    {
        return this.formatDate(this.deleted_at)
    }
}
